export enum PermissionErrorConstants {
  Title = 'Looks like you’re not an account admin',
  Subtitle = 'In order to set up integrations with Paddle, you must have admin permissions. Contact your Paddle administrator for help to get setup.',
  CTA = 'Go back to Paddle',
}
